import React, { useState } from "react";
import { Modal } from "@shopify/polaris";
import { useDispatch, useSelector } from "react-redux";

import { REVIEW_TRIGGERS, TRIGGER_FEATURE_NAMES } from "../../../CONSTANTS/reviewTriggers";
import { TRIGGER_TO_TOUCHPOINT } from "../../../CONSTANTS/reviewChips";
import { reviewActions } from "../../../store/review-slice";
import useReviewFlow from "../../../hooks/useReviewFlow";
import useBlockModalBackdropClose from "../../../hooks/useBlockModalBackdropClose";
import ReviewChips from "./ReviewChips";

// Generic standalone review prompt modal — used by Forecast Report,
// Best Sellers, and Sync Completed triggers (Figma images 2 + 5).
// Visibility is driven by Redux state.review.promptVisible.

const InAppReviewPrompt = () => {
  const dispatch = useDispatch();
  const { promptVisible, currentTrigger } = useSelector((state) => state.review);
  const { submitFeedback } = useReviewFlow();
  // Declared before the early return to respect the rules of hooks.
  const [selectedChip, setSelectedChip] = useState(null);
  useBlockModalBackdropClose(promptVisible);

  if (!promptVisible || !currentTrigger) return null;

  const featureName = TRIGGER_FEATURE_NAMES[currentTrigger] || "IFH";

  // PO_CREATED uses a flow-specific question; all other triggers use the generic one.
  const title =
    currentTrigger === REVIEW_TRIGGERS.PO_CREATED
      ? "Is the reorder export file format helping Shopify PO Creation?"
      : `Are you getting value from ${featureName}?`;

  const touchpoint = TRIGGER_TO_TOUCHPOINT[currentTrigger];

  const handleHelpful = () => submitFeedback(currentTrigger, "helpful");
  const handleNotHelpful = () => submitFeedback(currentTrigger, "not_helpful");
  const handleClose = () => {
    // Backdrop click is blocked (see useBlockModalBackdropClose), so this only
    // fires for the "X" button and Escape — both treated as dismiss.
    setSelectedChip(null);
    submitFeedback(currentTrigger, "dismissed");
    dispatch(reviewActions.hidePrompt());
  };

  return (
    <Modal
      open={promptVisible}
      onClose={handleClose}
      title={title}
      primaryAction={{
        content: "Write a review",
        disabled: !selectedChip,
        onAction: handleHelpful,
      }}
      secondaryActions={[
        {
          content: "😐 Not really",
          onAction: handleNotHelpful,
        },
      ]}
    >
      <Modal.Section>
        <ReviewChips
          touchpoint={touchpoint}
          selectedChip={selectedChip}
          onSelect={setSelectedChip}
        />
      </Modal.Section>
    </Modal>
  );
};

export default InAppReviewPrompt;
